import axios from 'axios'
import { logout } from '@/utils/authConfig'

const client = axios.create({ baseURL: process.env.NEXT_PUBLIC_APIM_BASE_PATH })

export const request = ({ ...options }) => {
  if (typeof window !== 'undefined') {
    const user = JSON.parse(localStorage.getItem('userDetails'))
    client.defaults.headers.common.Authorization = `Bearer ${user?.access_token}`
  }

  client.defaults.headers.common['Ocp-Apim-Subscription-Key'] =
    process.env.NEXT_PUBLIC_APIM_SUBSCRIPTION_KEY
  client.defaults.headers.common['Content-Type'] = 'application/json'
  const onSuccess = (response) => response
  const onError = (error) => (error.response.status == 401 ? logout() : error)
  return client(options).then(onSuccess).catch(onError)
}
